import stripWhitespaces from './string/stripWhitespaces';

export default contact => {
  const {
    given_name: givenName,
    additional_name: additionalName,
    family_name: familyName,
  } = contact;
  const formattedGivenName = givenName !== undefined && givenName !== null ? givenName : '';
  const formattedAdditionalName =
    additionalName !== undefined && additionalName !== null ? additionalName : '';
  const formattedFamilyName = familyName !== undefined && familyName !== null ? familyName : '';
  if (!givenName && !additionalName && !familyName) {
    return '';
  }

  return stripWhitespaces(
    `${formattedGivenName} ${formattedAdditionalName} ${formattedFamilyName}`,
  );
};
